import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AppError, AuthStatus, User } from './types';
import { normalizeAuthUser } from './utils/normalizeUser';

interface AuthState {
  status: AuthStatus;
  user: User | null;
  error: AppError | null;
}

const initialState: AuthState = {
  status: 'idle',
  user: null,
  error: null,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authBootStart(state) {
      state.status = 'booting';
      state.error = null;
    },
    authSucceeded(state, action: PayloadAction<User>) {
      state.status = 'authenticated';
      state.user = normalizeAuthUser(action.payload);
      state.error = null;
    },
    authFailed(state, action: PayloadAction<AppError | null>) {
      state.status = 'unauthenticated';
      state.user = null;
      state.error = action.payload;
    },
    loggedOut(state) {
      state.status = 'unauthenticated';
      state.user = null;
      state.error = null;
    },
  },
});

export const { authBootStart, authSucceeded, authFailed, loggedOut } = slice.actions;
export const authReducer = slice.reducer;
export type { AuthState };
